import { render, staticRenderFns } from "./ClinicSetting.vue?vue&type=template&id=15132335&scoped=true"
import script from "./ClinicSetting.vue?vue&type=script&lang=js"
export * from "./ClinicSetting.vue?vue&type=script&lang=js"
import style0 from "./ClinicSetting.vue?vue&type=style&index=0&id=15132335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15132335",
  null
  
)

export default component.exports